import React, { type ComponentType } from 'react';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { JswOnboardingChecklist } from '@atlassian/jira-software-onboarding-quickstart/src/ui/async.tsx';
import { shouldRouteSkipOnboarding } from '../../common/utils.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RightSidebars: ComponentType<Record<any, any>> = () => {
	const route = useCurrentRoute();

	if (shouldRouteSkipOnboarding(route.name)) {
		return null;
	}

	return <JswOnboardingChecklist />;
};

export default RightSidebars;
